export default __webpack_public_path__ + "static/media/84.11aa2d21.jpg";